/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commonbtnok2Inputs */



/**
* | output |
* | --- |
* | "OK" |
*
* @param {Commonbtnok2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const commonbtnok2 = /** @type {((inputs?: Commonbtnok2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commonbtnok2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("OK")
	if (locale === "es") return /** @type {LocalizedString} */ ("OK")
	return /** @type {LocalizedString} */ ("Окей")
});
export { commonbtnok2 as "commonBtnOk" }